jQuery(document).ready(function($){

  var headerHight =0;

  $('a[href^="#"]:not(.dns)').click(function(){
    var speed = 200;
    var href= $(this).attr("href");
    var target = $(href == "#" || href === "" ? 'html' : href);
    var position = target.offset().top ;
    $("html, body").animate({scrollTop:position}, speed, "swing");
    return false;
  });

  var spFlag;
  if($(window).width() < 769){
    spFlag = true;
  } else {
    spFlag = false;
  }

  $(window).resize(function(){
    if($(window).width() < 769){
      if(!spFlag){
        spFlag = true;
      }

    } else {
      if(spFlag){
        spFlag = false;

      }
    }
  });

  $('.page_nav.sp ul ul').hide();

  $('.ocbtn').on('click',function(){
    if($(this).hasClass('open')){
      $(this).removeClass('open');
      $('+ ul',this).stop().slideUp(200);
    } else {
      $(this).addClass('open');
      $('+ ul',this).slideDown(200);
    }
    return false;
  });

  if(spFlag){
    $('.channelCatBlock h5').on('click',function(){

      if($(this).hasClass('open')){
        $(this).removeClass('open');
        $('+ div',this).stop().slideUp(200);
      } else {
        $(this).addClass('open');
        $('+ div',this).slideDown(200);
      }
      return false;

    });
  }



  if ($('.cont02-04_img01')[0]) {new ScrollHint('.cont02-04_img01');}


});

$(function() {
  'use strict';
  var init, switchAccordion;
  switchAccordion = function(tg, area, openClass, closeClass, preloadImg) {
    var act, body, btn, preload;
    btn = $(tg);
    body = $(area);
    act = function() {
      if (btn.hasClass(closeClass)) {
        btn.removeClass(closeClass);
        btn.addClass(openClass);
        return body.slideDown();
      } else if (btn.hasClass(openClass)) {
        btn.removeClass(openClass);
        btn.addClass(closeClass);
        return body.slideUp();
      }
    };
    preload = function(src) {
      return $('<img />').attr('src', src);
    };
    body.hide();
    preload(preloadImg);
    return $(btn).on('click', function(e) {
      e.preventDefault();
      act();
      return false;
    });
  };
  init = function() {
    return switchAccordion('.js-attention-sub-btn', '.js-attention-sub-box', 'attention-sub-head-on', 'attention-sub-head-off', 'images/atten_sub_minus.png');
  };
  return init();
});
